import React, { Component } from 'react'
import $ from 'jquery'
import Select from 'react-select'
import { FormattedMessage } from 'react-intl'
import * as Utils from '../../commons/utils/Utils'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'

// VEC-3476: paso final del flujo de Mínimo Vital — se muestra solo cuando
// MinimoVitalModal concluye y el backend indica que ya no queda ninguna falla
// pendiente en ningún checklist del móvil (requiere_seleccion_estado_movil).
// El usuario elige a qué estado vuelve el móvil; se aplica con el mismo
// PUT /moviles/{id}/estado que ya usa el ABM/grilla de Móviles (MovilesGridRow.js),
// sin tocar ese endpoint ni ese componente.
class MinimoVitalSeleccionEstadoModal extends Component {
	constructor(props) {
		super(props);
		this.modalId = 'modal_minimo_vital_seleccion_estado';
		this.state = {
			estadoSeleccionado: null,
			motivo: '',
			submitting: false,
		};
		this.handleGuardar = this.handleGuardar.bind(this);
		this.handleCerrar = this.handleCerrar.bind(this);
	}

	componentDidMount() {
		let component = this;
		$('#' + this.modalId).modal({ backdrop: 'static' });
		$('#' + this.modalId).on('hidden.bs.modal', function () {
			component.props.onClose();
		});
	}

	componentWillUnmount() {
		$('#' + this.modalId).off('hidden.bs.modal');
	}

	handleCerrar() {
		$('#' + this.modalId).modal('hide');
	}

	handleGuardar() {
		let intl = this.props.intl;
		let component = this;
		let motivoRequerido = ConfigBusiness.get('moviles.motivo.cambioestado') === 'true';

		if (!this.state.estadoSeleccionado) return;
		if (motivoRequerido && !this.state.motivo.trim()) return;

		this.setState({ submitting: true });

		// VEC-3476: mismo criterio que usa el backend para el motivo de salida de
		// servicio (Controller/FormularioController.php) — referencia al checklist
		// que originó el retorno, para que esta línea del histórico no quede
		// indistinguible de un cambio de estado manual.
		let motivoUsuario = this.state.motivo.trim();
		let motivoFinal = 'Checklist #' + this.props.formularioId + (motivoUsuario ? (' - ' + motivoUsuario) : '');
		motivoFinal = motivoFinal.substring(0, 255);

		let body = { estado: this.state.estadoSeleccionado.value, activo: true, motivo: motivoFinal };

		Utils.sendDataMultilanguage('/moviles/' + this.props.movilId + '/estado', 'PUT', body, intl)
			.then(function () {
				$('#' + component.modalId).off('hidden.bs.modal');
				$('#' + component.modalId).modal('hide');
				component.props.onGuardado(component.state.estadoSeleccionado.value);
			})
			.catch(function () {
				component.setState({ submitting: false });
			});
	}

	render() {
		let intl = this.props.intl;
		let estados = (ConfigBusiness.get('moviles.estados') || '').split(',').filter(Boolean).map((e) => ({ value: e, label: e }));
		let motivoRequerido = ConfigBusiness.get('moviles.motivo.cambioestado') === 'true';

		return (
			<div className="modal fade" tabIndex="-1" id={this.modalId} role="dialog" aria-labelledby={this.modalId + '_label'}>
				<div className="modal-dialog modal-lg" role="document">
					<div className="modal-content">
						<div className="modal-header bg-fleet">
							<h4 className="modal-title text-white" id={this.modalId + '_label'}>
								<FormattedMessage id="formularios.minimoVital.seleccionEstado.titulo" defaultMessage="¿A qué estado vuelve el móvil?" />
							</h4>
						</div>
						<div className="modal-body">
							<p className="text-muted">
								<FormattedMessage id="formularios.minimoVital.seleccionEstado.texto" defaultMessage="Ya no quedan fallas de Mínimo Vital pendientes en este móvil. Elegí el estado al que vuelve." />
							</p>
							<div className="form-group">
								<label><FormattedMessage id="formularios.minimoVital.seleccionEstado.label_estado" defaultMessage="Estado *:" /></label>
								<Select
									options={estados}
									valueKey="value"
									labelKey="label"
									value={this.state.estadoSeleccionado}
									onChange={(e) => this.setState({ estadoSeleccionado: e })}
									placeholder={intl.formatMessage({ id: 'formularios.minimoVital.seleccionEstado.placeholder_estado', defaultMessage: 'Seleccioná un estado' })}
								/>
							</div>
							<div className="form-group">
								<label>
									<FormattedMessage
										id={motivoRequerido ? 'formularios.minimoVital.seleccionEstado.label_motivo_requerido' : 'formularios.minimoVital.seleccionEstado.label_motivo'}
										defaultMessage={motivoRequerido ? 'Motivo *:' : 'Motivo (opcional):'}
									/>
								</label>
								<textarea
									className="form-control"
									maxLength={240}
									value={this.state.motivo}
									onChange={(e) => this.setState({ motivo: e.target.value })}
								/>
							</div>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-secondary" onClick={this.handleCerrar} disabled={this.state.submitting}>
								<FormattedMessage id="formularios.minimoVital.seleccionEstado.boton_cerrar" defaultMessage="Ahora no" />
							</button>
							<button
								type="button"
								className="btn btn-primary"
								onClick={this.handleGuardar}
								disabled={this.state.submitting || !this.state.estadoSeleccionado || (motivoRequerido && !this.state.motivo.trim())}
							>
								{this.state.submitting && <i className="fa fa-spinner fa-spin mr-1"></i>}
								<FormattedMessage id="formularios.minimoVital.seleccionEstado.boton_guardar" defaultMessage="Guardar" />
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default MinimoVitalSeleccionEstadoModal
